export const TKeyMcp = {
  MCP_GUIDE_TITLE: "MCP_GUIDE_TITLE",
  MCP_GUIDE_INTRO: "MCP_GUIDE_INTRO",
  MCP_GUIDE_STEP_1: "MCP_GUIDE_STEP_1",
  MCP_GUIDE_STEP_2: "MCP_GUIDE_STEP_2",
  MCP_GUIDE_STEP_3: "MCP_GUIDE_STEP_3",
  MCP_GUIDE_URL_LABEL: "MCP_GUIDE_URL_LABEL",
  MCP_GUIDE_ADVANCED_TITLE: "MCP_GUIDE_ADVANCED_TITLE",
  MCP_GUIDE_ADVANCED_DESC: "MCP_GUIDE_ADVANCED_DESC",
  MCP_GUIDE_USAGE_TITLE: "MCP_GUIDE_USAGE_TITLE",
  MCP_GUIDE_USAGE_INTRO: "MCP_GUIDE_USAGE_INTRO",
  MCP_GUIDE_USAGE_EXAMPLE_1: "MCP_GUIDE_USAGE_EXAMPLE_1",
  MCP_GUIDE_USAGE_EXAMPLE_2: "MCP_GUIDE_USAGE_EXAMPLE_2",
  MCP_GUIDE_USAGE_EXAMPLE_3: "MCP_GUIDE_USAGE_EXAMPLE_3",
  MCP_GUIDE_USAGE_EXAMPLE_4: "MCP_GUIDE_USAGE_EXAMPLE_4",
  MCP_GUIDE_TOOLS_TITLE: "MCP_GUIDE_TOOLS_TITLE",
  MCP_GUIDE_GROUP_GENERAL: "MCP_GUIDE_GROUP_GENERAL",
  MCP_GUIDE_GROUP_OFFERS: "MCP_GUIDE_GROUP_OFFERS",
  MCP_GUIDE_GROUP_CLIENT_AVATAR: "MCP_GUIDE_GROUP_CLIENT_AVATAR",
  MCP_GUIDE_GROUP_CALL_ANALYSIS: "MCP_GUIDE_GROUP_CALL_ANALYSIS",
  MCP_GUIDE_GROUP_PROSPECT_SEARCH: "MCP_GUIDE_GROUP_PROSPECT_SEARCH",
  MCP_GUIDE_GROUP_MESSAGES_CONTENT: "MCP_GUIDE_GROUP_MESSAGES_CONTENT",
  MCP_GUIDE_TOOL_PROJECTS: "MCP_GUIDE_TOOL_PROJECTS",
  MCP_GUIDE_TOOL_OFFERS: "MCP_GUIDE_TOOL_OFFERS",
  MCP_GUIDE_TOOL_SAVE_OFFER: "MCP_GUIDE_TOOL_SAVE_OFFER",
  MCP_GUIDE_TOOL_AVATAR: "MCP_GUIDE_TOOL_AVATAR",
  MCP_GUIDE_TOOL_SAVE_AVATAR: "MCP_GUIDE_TOOL_SAVE_AVATAR",
  MCP_GUIDE_TOOL_UPLOAD_CALL: "MCP_GUIDE_TOOL_UPLOAD_CALL",
  MCP_GUIDE_TOOL_CALLS: "MCP_GUIDE_TOOL_CALLS",
  MCP_GUIDE_TOOL_CALL_ANALYSIS: "MCP_GUIDE_TOOL_CALL_ANALYSIS",
  MCP_GUIDE_TOOL_CALL_INSIGHTS: "MCP_GUIDE_TOOL_CALL_INSIGHTS",
  MCP_GUIDE_TOOL_CALL_PATTERNS: "MCP_GUIDE_TOOL_CALL_PATTERNS",
  MCP_GUIDE_TOOL_CRITERIA: "MCP_GUIDE_TOOL_CRITERIA",
  MCP_GUIDE_TOOL_SAVE_CRITERIA: "MCP_GUIDE_TOOL_SAVE_CRITERIA",
  MCP_GUIDE_TOOL_SEQUENCE_OBJECTIVES: "MCP_GUIDE_TOOL_SEQUENCE_OBJECTIVES",
  MCP_GUIDE_TOOL_SEQUENCE: "MCP_GUIDE_TOOL_SEQUENCE",
  MCP_GUIDE_TOOL_SAVE_SEQUENCE: "MCP_GUIDE_TOOL_SAVE_SEQUENCE",
  MCP_CONSENT_TITLE: "MCP_CONSENT_TITLE",
  MCP_CONSENT_DESC: "MCP_CONSENT_DESC",
  MCP_CONSENT_LOGIN_REQUIRED: "MCP_CONSENT_LOGIN_REQUIRED",
  MCP_CONSENT_LOGIN_BUTTON: "MCP_CONSENT_LOGIN_BUTTON",
  MCP_CONSENT_AUTHORIZE: "MCP_CONSENT_AUTHORIZE",
  MCP_CONSENT_DENY: "MCP_CONSENT_DENY",
  MCP_CONSENT_ERROR: "MCP_CONSENT_ERROR",
  MCP_CONSENT_INVALID: "MCP_CONSENT_INVALID",
} as const;
